import React, { useState } from 'react';
import Button from '~/app/components/Button';
import Modal from '~/app/components/Modal';
import TextInput from '~/app/components/TextInput';
import _ from 'shared/lib/gettext';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';

type Props = {
  onClose: () => void,
  onAddFolder: (name: string) => Promise<void>
}

const VALID_FOLDER_NAME_REGEX = /^[\w-]+$/;

export default function AddFolderModal(props: Props) {
  const {
    onClose,
    onAddFolder
  } = props;

  const [newFolderName, setNewFolderName] = useState('');

  const onChangeFolderName = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (VALID_FOLDER_NAME_REGEX.test(e.target.value)) {
      setNewFolderName(e.target.value);
    }
  };

  const actions = [
    <Button
      key="create"
      onClick={() => {
        onAddFolder(newFolderName);
      }}
    >
      {_('CREATE')}
    </Button>
  ]

  return (
    <Modal
      title={_('ADD_FOLDER')}
      modalStyle='auto'
      actions={actions}
      onClose={onClose}
    >
      <ModalBody>
        <label>{_('NEW_FOLDER_NAME')}</label>
        <TextInput
          value={newFolderName}
          onChange={onChangeFolderName}
          additionalStyles={{
            margin: '0',
          }}
        />
      </ModalBody>
    </Modal>
  );
}

const ModalBody = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: '14px',
  fontFamily: 'Montserrat, sans-serif',
  width: '388px'
});
